<div >
    
    <div class="container text-center mt-5 mb-5">
      <img src="../../../../assets/images/realdesk-logo.png">
    </div>

    <div class="container content-login">
      <div class="row">
        
        <div class="col-md-6">
          <img src="../../../../assets/images/ilustration_login.svg" class="img-fluid">
        </div>

        <div class="col-md-6 card">
          <div class="logo-client text-center mb-5 mt-3">
            <img src="../../../../assets/images/logo-notasimples.png" class="img-fluid">
          </div>

          <form class="form" [formGroup]="loginForm">
            <div class="mb-3">
              <label class="form-label">E-mail</label>
              <input type="text" class="form-control user" placeholder="Digite seu e-mail" formControlName="email">
                @if (loginForm.controls['email'].touched &&
                loginForm.controls['email'].errors?.['required']) {
                <div class="text text-danger mt-1"> Email é obrigatório</div>
                }
                @if (loginForm.controls['email'].touched &&
                loginForm.controls['email'].errors?.['email']) {
                <div class="text text-danger mt-1">Email inválido</div>
                }
            </div>

            <div class="mb-3">
              <label class="form-label">Nova Senha</label>
              <input type="password" class="form-control pass" placeholder="Digite sua senha" formControlName="password">
                @if (loginForm.controls['password'].touched &&
                loginForm.controls['password'].errors?.['required']) {
                <div class="text text-danger mt-1">
                    senha é obrigatória
                </div>
                }
            </div>

            <div class="mb-3 actions">
                <button class="btn btn-primary mb-3" [disabled]="!loginForm.valid || isLoading"
                    (click)="forgotPassword()"><i *ngIf="isLoading" class="fa fa-spin fa-spinner me-2"></i>
                    Criar nova senha</button>
            </div>
          </form>
        </div>

      </div>
    </div>
</div>